import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import { ListingCard } from "../components/ListingCard";

export default function Favorites() {
  const { t } = useI18n();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { if (user === false) navigate("/auth"); }, [user, navigate]);
  useEffect(() => {
    if (!user) return;
    api.get("/favorites").then(({ data }) => setListings(data)).catch(() => {}).finally(() => setLoading(false));
  }, [user]);

  const onFavToggle = (id, fav) => { if (!fav) setListings((ls) => ls.filter((l) => l.id !== id)); };

  return (
    <div className="px-4 sm:px-8 py-6">
      <h1 className="font-display font-extrabold text-2xl sm:text-3xl mb-6 flex items-center gap-2"><Heart className="h-6 w-6 text-rose-500 fill-rose-500" />{t("favorites.title")}</h1>
      {loading ? <div className="text-slate-400">{t("common.loading")}</div> :
        listings.length === 0 ? (
          <div data-testid="favorites-empty" className="text-center py-20 text-slate-400"><Heart className="h-12 w-12 mx-auto mb-3 opacity-30" />{t("favorites.empty")}</div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {listings.map((l, i) => <ListingCard key={l.id} listing={l} index={i} onFavToggle={onFavToggle} />)}
          </div>
        )}
    </div>
  );
}
